// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import firebase from "firebase/app"
import Toasted from 'vue-toasted'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.config.productionTip = false

let firebaseConfig = {}
if (window.location.origin === 'http://localhost:8080') {
  firebaseConfig = {
    apiKey: "AIzaSyD2lLiFYg8_v7DXrmc9zPKlvk4EVrKc_xY",
    authDomain: "certificate-generator-1d1ac.firebaseapp.com",
    databaseURL: "https://certificate-generator-1d1ac.firebaseio.com",
    projectId: "certificate-generator-1d1ac",
    storageBucket: "certificate-generator-1d1ac.appspot.com",
    messagingSenderId: "576857979923",
    appId: "1:576857979923:web:09fcd3ccd4abe0f2dc13e6"
  }
} else if (window.location.origin === 'https://diplomadigital.galileo.edu') {
  firebaseConfig = {
    apiKey: "AIzaSyAZjZfd_qQfLINHdjGYjrc34xDvvhNjCZI",
    authDomain: "diplomadigital.galileo.edu",
    databaseURL: "https://diplomasdigitales.firebaseio.com",
    projectId: "diplomasdigitales",
    storageBucket: "diplomasdigitales.appspot.com",
    messagingSenderId: "907868912953",
    appId: "1:907868912953:web:d1e6d26358960fb491fce8",
    measurementId: "G-2VL08LPMVF"
  }
} else {
  firebaseConfig = {
    apiKey: "AIzaSyD2lLiFYg8_v7DXrmc9zPKlvk4EVrKc_xY",
    authDomain: "certificate-generator-1d1ac.firebaseapp.com",
    databaseURL: "https://certificate-generator-1d1ac.firebaseio.com",
    projectId: "certificate-generator-1d1ac",
    storageBucket: "certificate-generator-1d1ac.appspot.com",
    messagingSenderId: "576857979923",
    appId: "1:576857979923:web:09fcd3ccd4abe0f2dc13e6"
  }
}
firebase.initializeApp(firebaseConfig);

const Options = {
  duration: 5000,
  position: 'top-right',
  action : {
    text : 'Cerrar',
    onClick : (e, toastObject) => {
        toastObject.goAway(0);
    }
  }
}
Vue.use(Toasted, Options)
library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },

  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js